import { Box, Divider, Typography } from '@mui/material';
import { ReactNode } from 'react';

export type SectionContainerProps = {
  children: ReactNode;
  title?: string;
  columns?: number;
};

export const SectionContainer = ({ columns = 3, children, title }: SectionContainerProps) => {
  return (
    <Box>
      {title ? (
        <Typography variant="h6" fontWeight="bold">
          {title}
        </Typography>
      ) : null}
      <Box
        sx={{
          display: { md: 'grid', xs: 'flex' },
          flexDirection: 'column',
          gap: 2,
          gridTemplateColumns: { md: `repeat(${columns}, 1fr)`, xs: '1fr' },
          marginBottom: 2,
          marginLeft: 0,
          marginTop: 2,
        }}
      >
        {children}
      </Box>
      <Divider />
    </Box>
  );
};
